<template>
    <SettingsPage title="Top Navigation">
        <template v-slot:settingsForms>
            <SettingsForm :settingsLoading="settingsLoading" form="newUserRegistration">
                <template v-slot:form>
                    <form v-if="!settingsLoading && settings && navigationLinks"
                          action=""
                          method="POST"
                          id="newUserRegistration"
                          @submit.prevent="saveNavigation"
                    >
                        <v-row>
                            <v-col cols="12" md="4">
                                <h3 class="mb-2">Slot 1</h3>
                                <v-autocomplete label="Page"
                                                :items="navigationLinks"
                                                item-text="name"
                                                item-value="id"
                                                name="page1"
                                                v-model="settings.slot1.navItem"
                                                outlined
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <h3 class="mb-2">Slot 2</h3>
                                <v-autocomplete label="Page"
                                                :items="navigationLinks"
                                                item-text="name"
                                                item-value="id"
                                                name="page2"
                                                v-model="settings.slot2.navItem"
                                                outlined
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <h3 class="mb-2">Slot 3</h3>
                                <v-autocomplete label="Page"
                                                :items="navigationLinks"
                                                item-text="name"
                                                item-value="id"
                                                name="page3"
                                                v-model="settings.slot3.navItem"
                                                outlined
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </form>
                </template>
            </SettingsForm>
        </template>
    </SettingsPage>
</template>

<script>
import settingsMixin from '@/views/Admin/Config/Settings/Common/settingsMixin';
import SettingsPage from '@/views/Admin/Config/Settings/Common/SettingsPage';
import SettingsForm from '@/views/Admin/Config/Settings/Common/SettingsForm';
import axios from 'axios';

export default {
    mixins: [settingsMixin],
    components: { SettingsForm, SettingsPage },
    props: [],

    data() {
        return {
            navigationLinks: [],
            settingPage: 'navigation',
            settingName: 'settingNavigation'
        };
    },

    mounted() {
        this.getNavigationLinks();
    },

    methods: {
        getNavigationLinks() {
            axios.get('/api/navigation-link/index')
                .then(response => {
                    this.navigationLinks = response.data.data.navigationLinks.links;
                })
                .catch(error => {
                    console.error(error);
                });
        },

        saveNavigation() {
            const settings = {
                slot1: {
                    navItem: this.settings.slot1.navItem
                },

                slot2: {
                    navItem: this.settings.slot2.navItem
                },

                slot3: {
                    navItem: this.settings.slot3.navItem
                }
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}`, settings));
        }
    }
};
</script>
